export const findSmallestDifferenceBetweenTwoNumbers = (numbers: number[]): number => {
  let smallestDifference = Number.MAX_SAFE_INTEGER;

  for (let i = 0; i < numbers.length - 1; i++) {
    const difference = numbers[i + 1] - numbers[i];
    if (difference < smallestDifference) {
      smallestDifference = difference;
    }
  }

  return smallestDifference;
};
